(function(){
  'use strict';

  function qs(r,s){return r.querySelector(s)}
  function qsa(r,s){return Array.prototype.slice.call(r.querySelectorAll(s))}
  function mod(n,m){return ((n%m)+m)%m}
  function clamp(v,a,b){return Math.max(a,Math.min(b,v))}
  function lerp(a,b,t){return a+(b-a)*t}
  function shortestAngle(a){while(a>Math.PI)a-=Math.PI*2;while(a<-Math.PI)a+=Math.PI*2;return a}
  function seeded(seed){return function(){seed=(seed*1664525+1013904223)>>>0;return seed/4294967296}}

  function init(root){
    if(!root||root.dataset.h4Ready==='1')return;
    root.dataset.h4Ready='1';

    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var stage=qs(root,'[data-h4-stage]');
    var stars=qs(root,'[data-h4-stars]');
    var mobileStars=qs(root,'[data-h4-stars-mobile]');
    var nodes=qsa(root,'[data-h4-node]');
    var svg=qs(root,'[data-h4-orbits]');
    var rings=qsa(root,'[data-h4-ring]');
    var focusLine=qs(root,'[data-h4-focus-line]');
    var motionToggle=qs(root,'[data-h4-motion-toggle]');

    var starCache=new WeakMap();
    function makeStars(canvas,seed,count){
      if(!canvas)return null;
      var rect=canvas.getBoundingClientRect();
      if(!rect.width||!rect.height)return null;
      var dpr=Math.min(window.devicePixelRatio||1,2);
      var old=starCache.get(canvas);
      if(old&&Math.abs(old.w-rect.width)<2&&Math.abs(old.h-rect.height)<2)return old;
      canvas.width=Math.round(rect.width*dpr);
      canvas.height=Math.round(rect.height*dpr);
      var rnd=seeded(seed),list=[];
      for(var i=0;i<count;i++){
        list.push({x:rnd()*rect.width,y:rnd()*rect.height,r:.35+rnd()*1.15,a:.16+rnd()*.58,p:rnd()*Math.PI*2,t:rnd()});
      }
      var data={w:rect.width,h:rect.height,dpr:dpr,list:list};
      starCache.set(canvas,data);
      return data;
    }
    function paintCosmicBackdrop(ctx,d,seed,isMobile){
      var rnd=seeded((seed^0x9e3779b9)>>>0),w=d.w,h=d.h;
      ctx.save();
      ctx.globalCompositeOperation='screen';

      function cloud(x,y,rx,ry,stops){
        ctx.save();ctx.translate(x,y);ctx.scale(1,ry/rx);
        var g=ctx.createRadialGradient(0,0,0,0,0,rx);
        stops.forEach(function(s){g.addColorStop(s[0],s[1])});
        ctx.fillStyle=g;ctx.beginPath();ctx.arc(0,0,rx,0,Math.PI*2);ctx.fill();ctx.restore();
      }
      cloud(w*.22,h*.48,w*(isMobile?.40:.28),h*.34,[
        [0,'rgba(28,88,255,.16)'],[.34,'rgba(40,57,178,.11)'],[.72,'rgba(20,12,68,.06)'],[1,'rgba(0,0,0,0)']
      ]);
      cloud(w*.50,h*.54,w*(isMobile?.46:.36),h*.39,[
        [0,'rgba(255,49,177,.22)'],[.28,'rgba(151,53,255,.19)'],[.62,'rgba(76,29,132,.09)'],[1,'rgba(0,0,0,0)']
      ]);
      cloud(w*.78,h*.46,w*(isMobile?.34:.26),h*.32,[
        [0,'rgba(173,31,255,.13)'],[.38,'rgba(255,34,151,.09)'],[1,'rgba(0,0,0,0)']
      ]);

      if(!isMobile){
        ctx.save();ctx.translate(w*.48,h*.54);ctx.rotate(-.11);ctx.scale(1,.34);
        for(var a=0;a<5;a++){
          ctx.beginPath();
          ctx.ellipse(0,0,w*(.18+a*.055),h*(.17+a*.04),0,0,Math.PI*2);
          ctx.strokeStyle=a%2?'rgba(255,43,174,'+(.035+a*.012)+')':'rgba(74,122,255,'+(.035+a*.012)+')';
          ctx.lineWidth=8+a*4;ctx.stroke();
        }
        ctx.restore();
      }

      var flareCount=isMobile?4:16;
      for(var f=0;f<flareCount;f++){
        var fx=(.06+rnd()*.88)*w,fy=(.10+rnd()*.80)*h,fr=isMobile?12+rnd()*16:16+rnd()*34;
        var fg=ctx.createRadialGradient(fx,fy,0,fx,fy,fr);
        var hot=rnd()>.55?'255,55,188':'83,153,255';
        fg.addColorStop(0,'rgba(255,255,255,.96)');
        fg.addColorStop(.08,'rgba('+hot+',.78)');
        fg.addColorStop(.38,'rgba('+hot+',.16)');
        fg.addColorStop(1,'rgba('+hot+',0)');
        ctx.fillStyle=fg;ctx.fillRect(fx-fr,fy-fr,fr*2,fr*2);
        ctx.save();ctx.translate(fx,fy);ctx.rotate((rnd()-.5)*.8);
        ctx.strokeStyle='rgba(255,255,255,.32)';ctx.lineWidth=.7;
        ctx.beginPath();ctx.moveTo(-fr*1.9,0);ctx.lineTo(fr*1.9,0);ctx.stroke();
        ctx.restore();
      }

      /* H113SWIRL — static turbulent accretion/nebula bands behind the live hole. */
      ctx.save();
      ctx.translate(w*.50,h*.49);
      ctx.rotate(-.10);
      ctx.globalCompositeOperation='screen';
      var swirlCount=isMobile?9:28;
      for(var sw=0;sw<swirlCount;sw++){
        var srX=w*((isMobile?.10:.12)+rnd()*(isMobile?.19:.24));
        var srY=h*((isMobile?.035:.025)+rnd()*(isMobile?.065:.095));
        var st=rnd()*Math.PI*2;
        var span=Math.PI*(.28+rnd()*1.05);
        ctx.beginPath();
        ctx.ellipse(0,0,srX,srY,0,st,st+span);
        var sc=rnd();
        var sa=.035+rnd()*.18;
        ctx.strokeStyle=sc>.68?'rgba(255,241,184,'+sa+')':sc>.34?'rgba(255,74,181,'+sa+')':'rgba(137,74,255,'+sa+')';
        ctx.lineWidth=.5+rnd()*(isMobile?1.3:2.8);
        ctx.stroke();
      }
      ctx.restore();

      /* H11NEBULADUST — static high-frequency nebula texture, painted once. */
      var dustCount=isMobile?54:190;
      for(var du=0;du<dustCount;du++){
        var ang=rnd()*Math.PI*2,rad=Math.sqrt(rnd());
        var dx=w*.50+Math.cos(ang)*w*(isMobile?.40:.43)*rad;
        var dy=h*.54+Math.sin(ang)*h*(isMobile?.30:.34)*rad;
        var ds=.3+rnd()*1.35;
        var da=.025+rnd()*.15;
        var dc=rnd();
        ctx.beginPath();ctx.arc(dx,dy,ds,0,Math.PI*2);
        ctx.fillStyle=dc>.72?'rgba(255,61,184,'+da+')':dc>.40?'rgba(152,88,255,'+da+')':'rgba(64,142,255,'+da+')';
        ctx.fill();
      }

      /* H114CLUSTERS — richer static galactic dust and hot knots, painted once. */
      ctx.save();
      ctx.globalCompositeOperation='screen';
      var clusterCount=isMobile?40:150;
      for(var cl=0;cl<clusterCount;cl++){
        var side=rnd()>.5?1:-1;
        var cx0=w*(side>0?.72:.28)+(rnd()-.5)*w*(isMobile?.16:.24);
        var cy0=h*(.48+(rnd()-.5)*(isMobile?.34:.44));
        var cr=.4+rnd()*(isMobile?1.2:1.8);
        var ca=.035+rnd()*.19;
        var cc=rnd();
        ctx.beginPath();ctx.arc(cx0,cy0,cr,0,Math.PI*2);
        ctx.fillStyle=cc>.70?'rgba(255,70,190,'+ca+')':cc>.40?'rgba(131,86,255,'+ca+')':'rgba(57,141,255,'+ca+')';
        ctx.fill();
      }
      ctx.restore();

            /* H112FILAMENTS — static spiral/nebula detail matching the master reference. */
      ctx.save();
      ctx.globalCompositeOperation='screen';
      var filaments=isMobile?8:24;
      for(var fi=0;fi<filaments;fi++){
        var sideBand=rnd()>.5?1:-1;
        var y0=h*(.22+rnd()*.58);
        var x0=w*(sideBand>0?.53:.05);
        var x1=w*(sideBand>0?.96:.47);
        var bend=(rnd()-.5)*h*.22;
        ctx.beginPath();
        ctx.moveTo(x0,y0);
        ctx.bezierCurveTo(
          x0+(x1-x0)*.28,y0+bend,
          x0+(x1-x0)*.66,y0-bend*.55,
          x1,y0+(rnd()-.5)*h*.09
        );
        var fa=.025+rnd()*.075;
        var fc=rnd();
        ctx.strokeStyle=fc>.62?'rgba(255,56,184,'+fa+')':fc>.30?'rgba(142,76,255,'+fa+')':'rgba(63,135,255,'+fa+')';
        ctx.lineWidth=.35+rnd()*1.15;
        ctx.stroke();
      }
      ctx.restore();

      ctx.restore();

      if(!isMobile){
        ctx.save();ctx.globalCompositeOperation='source-over';
        /* H112ROCKS — jagged edge debris, not rectangular placeholders. */
        var shardCount=0;
        for(var sh=0;sh<shardCount;sh++){
          var side=rnd()>.5?1:0;
          var sx=(side?(.86+rnd()*.13):(.01+rnd()*.13))*w;
          var sy=(.12+rnd()*.78)*h;
          var sr=8+rnd()*22;
          ctx.save();ctx.translate(sx,sy);ctx.rotate(rnd()*Math.PI);
          var pts=[],pc=6+Math.floor(rnd()*3);
          for(var pp=0;pp<pc;pp++){
            var pa=Math.PI*2*pp/pc+(rnd()-.5)*.32;
            var pr=sr*(.46+rnd()*.62);
            pts.push([Math.cos(pa)*pr,Math.sin(pa)*pr]);
          }
          ctx.beginPath();ctx.moveTo(pts[0][0],pts[0][1]);
          for(var pv=1;pv<pts.length;pv++)ctx.lineTo(pts[pv][0],pts[pv][1]);
          ctx.closePath();
          var rg=ctx.createLinearGradient(-sr,-sr,sr,sr);
          rg.addColorStop(0,'rgba(17,10,25,.98)');
          rg.addColorStop(.55,'rgba(5,4,10,.98)');
          rg.addColorStop(1,'rgba(29,10,35,.94)');
          ctx.fillStyle=rg;ctx.fill();
          ctx.strokeStyle=rnd()>.5?'rgba(173,79,255,.34)':'rgba(255,61,177,.28)';
          ctx.lineWidth=.8;ctx.stroke();
          ctx.beginPath();ctx.moveTo(pts[0][0],pts[0][1]);ctx.lineTo(0,0);ctx.lineTo(pts[Math.floor(pts.length*.55)][0],pts[Math.floor(pts.length*.55)][1]);
          ctx.strokeStyle='rgba(255,255,255,.055)';ctx.lineWidth=.55;ctx.stroke();
          ctx.restore();
        }
        ctx.restore();
      }
    }

    function drawStars(canvas,seed,count,time){
      var d=makeStars(canvas,seed,count);if(!d)return;
      var ctx=canvas.getContext('2d');ctx.setTransform(d.dpr,0,0,d.dpr,0,0);ctx.clearRect(0,0,d.w,d.h);
      var isMobile=canvas===mobileStars;
      paintCosmicBackdrop(ctx,d,seed,isMobile);
      ctx.save();ctx.globalCompositeOperation='screen';
      for(var i=0;i<d.list.length;i++){
        var s=d.list[i],a=s.a*(s.t>.86?1.15:.88);
        ctx.beginPath();ctx.arc(s.x,s.y,s.r*(s.t>.94?1.7:1),0,Math.PI*2);
        ctx.fillStyle=s.t>.94?'rgba(255,240,171,'+a+')':s.t>.78?'rgba(199,178,255,'+a+')':'rgba(255,255,255,'+a+')';
        ctx.fill();
      }
      ctx.restore();
    }

    var ringCount=[0,0,0];
    nodes.forEach(function(node,i){
      var ring=i%3;
      node._h4={ring:ring,slot:ringCount[ring]++};
      var ringRgb=['114,236,255','155,98,255','255,59,167'][ring];
      var ringHex=['#72ecff','#9b62ff','#ff3ba7'][ring];
      node.style.setProperty('--h8-ring-rgb',ringRgb);
      node.style.setProperty('--h8-ring',ringHex);
    });
    var offsets=[-.72,.38,-1.18];
    var speeds=[.000048,-.000033,.000025];
    var motion=reduce?0:1,targetMotion=reduce?0:1,userPaused=reduce;
    var activeNode=null;
    var pointerX=0,pointerY=0,targetPointerX=0,targetPointerY=0;
    var dragging=false,dragLastX=0,dragMoved=0;
    var last=performance.now();
    /* H7PERF */
    var frameBudget=1000/30,lastFrame=0,sceneVisible=true,pageVisible=!document.hidden;
    var starsDirtyDesktop=true,starsDirtyMobile=true;

    function metrics(){
      if(!stage)return null;
      var r=stage.getBoundingClientRect();
      if(!r.width||!r.height)return null;
      var w=r.width,h=r.height,cx=w*.5+pointerX*8,cy=h*.5+pointerY*5;
      /* H10RINGS */
      var rx=[Math.min(w*.225,320),Math.min(w*.34,500),Math.min(w*.455,690)];
      var ry=[Math.min(h*.19,122),Math.min(h*.30,195),Math.min(h*.405,270)];
      return {r:r,w:w,h:h,cx:cx,cy:cy,rx:rx,ry:ry};
    }

    function renderDesktop(now,dt){
      if(!stage||window.innerWidth<=860)return;
      var m=metrics();if(!m)return;
      pointerX=lerp(pointerX,targetPointerX,.08);
      pointerY=lerp(pointerY,targetPointerY,.08);
      if(!userPaused&&!dragging&&!reduce){
        for(var k=0;k<3;k++)offsets[k]+=speeds[k]*dt*motion;
      }
      motion=lerp(motion,targetMotion,.055);
      root.style.setProperty('--h5-px',(pointerX*14).toFixed(2));
      root.style.setProperty('--h5-py',(pointerY*10).toFixed(2));

      if(svg)svg.setAttribute('viewBox','0 0 '+m.w+' '+m.h);
      rings.forEach(function(el,i){
        el.setAttribute('cx',m.cx);el.setAttribute('cy',m.cy);el.setAttribute('rx',m.rx[i]);el.setAttribute('ry',m.ry[i]);
      });

      nodes.forEach(function(node){
        var info=node._h4,ring=info.ring,count=ringCount[ring]||1;
        var ang=offsets[ring]+Math.PI*2*info.slot/count;
        var sin=Math.sin(ang),depth=(sin+1)/2;
        var x=m.cx+Math.cos(ang)*m.rx[ring],y=m.cy+sin*m.ry[ring];
        var base=[84,71,58][ring];
        var size=Math.round(base*(.82+depth*.34));
        var opacity=(ring===2?.68:.74)+depth*(ring===2?.30:.26);
        node.style.setProperty('--h83-x',(x-m.w*.5).toFixed(2)+'px');
        node.style.setProperty('--h83-y',(y-m.h*.5).toFixed(2)+'px');
        node.style.setProperty('--s',size+'px');
        node.style.setProperty('--h5-o',clamp(opacity,.42,1).toFixed(3));
        node.style.setProperty('--h5-z',String(8+ring+Math.round(depth*40)));node.style.setProperty('--h6-depth',depth.toFixed(3));
        node.classList.toggle('is-front',depth>.63);
        node.classList.toggle('is-back',depth<.28);
        node.classList.toggle('is-bottom',sin>.45);
        var coreNear=Math.abs(x-m.cx)<m.w*.115&&Math.abs(y-m.cy)<m.h*.18;
        node.classList.toggle('is-core-near',coreNear);
      });

      if(activeNode&&focusLine){
        var nr=activeNode.getBoundingClientRect(),sr=m.r;
        focusLine.setAttribute('x1',m.cx);focusLine.setAttribute('y1',m.cy);
        focusLine.setAttribute('x2',nr.left-sr.left+nr.width/2);
        focusLine.setAttribute('y2',nr.top-sr.top+nr.height/2);
      }
      if(starsDirtyDesktop){drawStars(stars,421337,270,0);starsDirtyDesktop=false;}
    }

    if(stage){
      stage.addEventListener('pointermove',function(e){
        var r=stage.getBoundingClientRect();
        targetPointerX=clamp((e.clientX-r.left)/r.width*2-1,-1,1);
        targetPointerY=clamp((e.clientY-r.top)/r.height*2-1,-1,1);
        if(dragging){
          var dx=e.clientX-dragLastX;dragLastX=e.clientX;dragMoved+=Math.abs(dx);
          offsets[0]+=dx*.0028;offsets[1]+=dx*.0021;offsets[2]+=dx*.00165;
          targetMotion=0;
        }else if(!activeNode){
          targetMotion=userPaused?0:0;
        }
      },{passive:true});
      stage.addEventListener('pointerleave',function(){
        targetPointerX=0;targetPointerY=0;
        if(!activeNode&&!dragging)targetMotion=userPaused?0:1;
      },{passive:true});
      stage.addEventListener('pointerdown',function(e){
        if(e.button!==undefined&&e.button!==0)return;
        dragging=true;root.classList.add('is-dragging');dragLastX=e.clientX;dragMoved=0;targetMotion=0;
        if(stage.setPointerCapture)try{stage.setPointerCapture(e.pointerId)}catch(_){}
      });
      stage.addEventListener('pointerup',function(e){
        dragging=false;root.classList.remove('is-dragging');
        if(stage.releasePointerCapture)try{stage.releasePointerCapture(e.pointerId)}catch(_){}
        targetMotion=userPaused?0:(activeNode?.08:1);
        setTimeout(function(){dragMoved=0},0);
      });
      stage.addEventListener('pointercancel',function(){dragging=false;root.classList.remove('is-dragging');targetMotion=userPaused?0:1});
    }

    if(motionToggle){
      motionToggle.addEventListener('pointerdown',function(e){e.stopPropagation()});
      motionToggle.addEventListener('click',function(e){
        e.preventDefault();e.stopPropagation();
        userPaused=!userPaused;targetMotion=userPaused?0:1;
        motionToggle.setAttribute('aria-pressed',userPaused?'true':'false');
        motionToggle.textContent=userPaused?'Resume motion':'Pause motion';
      });
    }

    var idle=qs(root,'[data-h4-inspector-idle]'),active=qs(root,'[data-h4-inspector-active]');
    var iImg=qs(root,'[data-h4-inspector-img]'),iTitle=qs(root,'[data-h4-inspector-title]'),iCount=qs(root,'[data-h4-inspector-count]'),iCta=qs(root,'[data-h4-inspector-cta]');
    function inspect(node,on){
      nodes.forEach(function(n){n.classList.toggle('is-active',on&&n===node)});
      activeNode=on?node:null;
      root.classList.toggle('is-inspecting',!!activeNode);
      if(activeNode&&activeNode._h4)root.setAttribute('data-h4-focus-ring',String(activeNode._h4.ring));
      else root.removeAttribute('data-h4-focus-ring');
      targetMotion=userPaused?0:(on?.06:1);
      if(!on||!node){
        if(idle)idle.hidden=false;if(active)active.hidden=true;if(focusLine)focusLine.classList.remove('is-visible');return;
      }
      if(idle)idle.hidden=true;if(active)active.hidden=false;if(focusLine)focusLine.classList.add('is-visible');
      var img=qs(node,'img'),src=node.dataset.hi||(img&&(img.currentSrc||img.src))||'';
      if(iImg){if(src){iImg.src=src;iImg.alt=node.dataset.title||'';iImg.hidden=false}else{iImg.hidden=true}}
      if(iTitle)iTitle.textContent=node.dataset.title||'';
      if(iCount)iCount.textContent=(node.dataset.count||0)+' designs';
      if(iCta)iCta.href=node.dataset.url||node.href;
    }
    nodes.forEach(function(node){
      node.addEventListener('mouseenter',function(){inspect(node,true)});
      node.addEventListener('mouseleave',function(){inspect(node,false)});
      node.addEventListener('focus',function(){inspect(node,true)});
      node.addEventListener('blur',function(){inspect(node,false)});
      node.addEventListener('click',function(e){if(dragMoved>7)e.preventDefault()});
    });

    var search=qs(root,'[data-h4-search]'),results=qs(root,'[data-h4-results]'),resultItems=qsa(root,'[data-h4-result]');
    function filterSearch(){
      if(!search)return;
      var t=search.value.trim().toLowerCase(),any=false;
      resultItems.forEach(function(item){var show=!t||(item.dataset.query||'').toLowerCase().indexOf(t)!==-1;item.hidden=!show;if(show)any=true});
      if(results)results.classList.toggle('is-open',!!t&&any);
    }
    if(search){
      search.addEventListener('input',filterSearch);search.addEventListener('focus',filterSearch);
      search.addEventListener('keydown',function(e){if(e.key==='Escape'){search.value='';filterSearch();search.blur()}});
    }
    document.addEventListener('keydown',function(e){if((e.metaKey||e.ctrlKey)&&e.key.toLowerCase()==='k'&&search&&window.innerWidth>860){e.preventDefault();search.focus()}});
    document.addEventListener('pointerdown',function(e){if(results&&!root.contains(e.target))results.classList.remove('is-open')});

    var mNodes=qsa(root,'[data-h4-mobile-node]'),mTitle=qs(root,'[data-h4-mobile-title]'),mCount=qs(root,'[data-h4-mobile-count]');
    var mOpen=qs(root,'[data-h4-mobile-open]'),mPrev=qs(root,'[data-h4-prev]'),mNext=qs(root,'[data-h4-next]');
    var mImg=qs(root,'[data-h4-mobile-img]'),mIndex=qs(root,'[data-h4-mobile-index]'),mScene=qs(root,'[data-h4-mobile-scene]');
    var mAngle=-Math.PI/2,mCurrent=-1,mDragging=false,mLastX=0,mLastT=0,mDragVelocity=0,mMoved=0;
    var mSceneW=0,mSceneH=0;
    var mAuto=reduce?0:.000045;
    function refreshMobileMetrics(rect){
      if(!mScene)return;
      var r=rect||mScene.getBoundingClientRect();
      mSceneW=r.width||mScene.clientWidth||0;
      mSceneH=r.height||mScene.clientHeight||0;
    }
    refreshMobileMetrics();

    function setMobileCard(index){
      if(index===mCurrent||!mNodes.length)return;
      mCurrent=index;
      root.setAttribute('data-h4-mobile-ring',String(index%3));
      var a=mNodes[index];if(!a)return;
      if(mTitle)mTitle.textContent=a.dataset.title||'';
      if(mCount)mCount.textContent=(a.dataset.count||0)+' designs';
      if(mOpen)mOpen.href=a.dataset.url||a.href;
      if(mIndex)mIndex.textContent=String(index+1).padStart(2,'0')+' / '+String(mNodes.length).padStart(2,'0');
      if(mImg){var im=qs(a,'img'),src=im&&(im.currentSrc||im.src);if(src){mImg.src=src;mImg.alt=a.dataset.title||'';mImg.hidden=false}else mImg.hidden=true}
    }
    function renderMobile(now,dt){
      if(window.innerWidth>860||!mNodes.length||!mScene)return;
      if(!mDragging&&!reduce){
        if(Math.abs(mDragVelocity)>.000003){
          mAngle+=mDragVelocity*dt;
          mDragVelocity*=Math.pow(.93,dt/16.67);
        }else{
          mDragVelocity=0;mAngle+=mAuto*dt;
        }
      }

      /* H122MOBILE — restore the preferred V11 single-ellipse composition exactly,
         while keeping V12's early front prediction and compositor movement. */
      if(!mSceneW||!mSceneH)refreshMobileMetrics();
      var n=mNodes.length,r={width:mSceneW,height:mSceneH},frontIndex=0,best=99,states=[];
      var lookVelocity=mDragging?mDragVelocity:(Math.abs(mDragVelocity)>.000003?mDragVelocity:mAuto);
      var lookahead=clamp(lookVelocity*84,-.15,.15);

      mNodes.forEach(function(node,i){
        var ang=mAngle+Math.PI*2*i/n;
        var projected=ang+lookahead;
        var sin=Math.sin(ang),cos=Math.cos(ang),depth=(sin+1)/2;
        var pDepth=(Math.sin(projected)+1)/2;
        var dist=Math.abs(shortestAngle(projected-Math.PI/2));
        if(dist<best){best=dist;frontIndex=i}
        states.push({
          node:node,
          depth:depth,
          pDepth:pDepth,
          dist:dist,
          x:cos*r.width*.415,
          y:sin*r.height*.295
        });
      });

      states.forEach(function(s,i){
        var node=s.node;
        var selected=i===frontIndex;
        var leading=s.dist<.54&&!selected;
        var desiredSize=20+s.depth*44;
        var scale=desiredSize/64;
        var opacity=s.depth<.08?0:clamp(.06+s.depth*.96,0,1);
        var proximity=clamp(1-s.dist/1.15,0,1);
        var z=3+Math.round(s.pDepth*30+proximity*90);

        node.classList.toggle('is-current',selected);
        node.classList.toggle('is-leading',leading);
        node.style.left='50%';node.style.top='50%';
        node.style.setProperty('--h12-mx',s.x.toFixed(2)+'px');
        node.style.setProperty('--h12-my',s.y.toFixed(2)+'px');
        node.style.setProperty('--h12-ms',scale.toFixed(4));
        node.style.setProperty('--h5-mo',opacity.toFixed(3));
        node.style.setProperty('--h5-mz',String(z));
        node.style.zIndex=String(selected?2000:(leading?1200:z));
        node.style.pointerEvents=s.pDepth>.30?'auto':'none';
        node.tabIndex=selected?0:-1;
      });

      setMobileCard(frontIndex);
      if(starsDirtyMobile){drawStars(mobileStars,742211,120,0);starsDirtyMobile=false;}
    }
    function rotateMobileTo(index){
      if(!mNodes.length)return;
      var n=mNodes.length,target=Math.PI/2-Math.PI*2*index/n;
      mAngle+=shortestAngle(target-mAngle);mDragVelocity=0;setMobileCard(index);
    }
    function stepMobile(d){if(!mNodes.length)return;rotateMobileTo(mod((mCurrent<0?0:mCurrent)+d,mNodes.length))}
    if(mPrev)mPrev.addEventListener('click',function(e){e.stopPropagation();stepMobile(-1)});
    if(mNext)mNext.addEventListener('click',function(e){e.stopPropagation();stepMobile(1)});
    mNodes.forEach(function(node,i){
      node.addEventListener('click',function(e){
        if(mMoved>8){e.preventDefault();return}
        if(i!==mCurrent){e.preventDefault();rotateMobileTo(i)}
      });
    });
    if(mScene){
      mScene.addEventListener('pointerdown',function(e){
        mDragging=true;root.classList.add('is-mobile-dragging');mLastX=e.clientX;mLastT=performance.now();mMoved=0;mDragVelocity=0;
        if(mScene.setPointerCapture)try{mScene.setPointerCapture(e.pointerId)}catch(_){}
      });
      mScene.addEventListener('pointermove',function(e){
        if(!mDragging)return;
        var now=performance.now(),dx=e.clientX-mLastX,dt=Math.max(8,now-mLastT);
        mAngle+=dx*.0062;mDragVelocity=dx*.0062/dt;mMoved+=Math.abs(dx);mLastX=e.clientX;mLastT=now;
      });
      function endMobile(e){
        if(!mDragging)return;mDragging=false;root.classList.remove('is-mobile-dragging');
        if(mScene.releasePointerCapture)try{mScene.releasePointerCapture(e.pointerId)}catch(_){}
        setTimeout(function(){mMoved=0},0);
      }
      mScene.addEventListener('pointerup',endMobile);mScene.addEventListener('pointercancel',endMobile);
    }

    var sheet=qs(root,'[data-h4-sheet]'),back=qs(root,'[data-h4-sheet-backdrop]'),openers=qsa(root,'[data-h4-open-sheet]');
    var close=qs(root,'[data-h4-sheet-close]'),sSearch=qs(root,'[data-h4-sheet-search]'),sItems=qsa(root,'[data-h4-sheet-item]');
    var sheetScrollLock={html:'',body:''};
    function openSheet(){
      if(!sheet||!back)return;
      sheetScrollLock.html=document.documentElement.style.overflow||'';
      sheetScrollLock.body=document.body.style.overflow||'';
      sheet.classList.add('is-open');back.classList.add('is-open');sheet.setAttribute('aria-hidden','false');
      document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';
      requestAnimationFrame(function(){if(sSearch&&window.innerWidth>860)sSearch.focus({preventScroll:true})});
    }
    function closeSheet(){
      if(!sheet||!back)return;
      sheet.classList.remove('is-open');back.classList.remove('is-open');sheet.setAttribute('aria-hidden','true');
      document.documentElement.style.overflow=sheetScrollLock.html;document.body.style.overflow=sheetScrollLock.body;
      if(sSearch)sSearch.value='';
      sItems.forEach(function(i){i.hidden=false});
    }
    openers.forEach(function(b){b.addEventListener('click',openSheet)});
    if(close)close.addEventListener('click',closeSheet);if(back)back.addEventListener('click',closeSheet);
    if(sSearch)sSearch.addEventListener('input',function(){var t=sSearch.value.trim().toLowerCase();sItems.forEach(function(i){i.hidden=!!t&&(i.dataset.query||'').toLowerCase().indexOf(t)===-1})});
    document.addEventListener('keydown',function(e){if(e.key==='Escape'&&sheet&&sheet.classList.contains('is-open'))closeSheet()});

    function tick(now){
      requestAnimationFrame(tick);
      if(!pageVisible||!sceneVisible)return;
      var budget=window.innerWidth<=860?10:frameBudget;
      if(now-lastFrame<budget)return;
      var dt=Math.min(50,Math.max(0,now-last));last=now;lastFrame=now;
      if(window.innerWidth>860)renderDesktop(now,dt);
      else renderMobile(now,dt);
    }

    if('IntersectionObserver'in window){
      var perfObserver=new IntersectionObserver(function(entries){
        sceneVisible=entries.some(function(entry){return entry.isIntersecting});
        root.classList.toggle('h4-perf-paused',!sceneVisible);
        if(sceneVisible){last=performance.now();lastFrame=0}
      },{rootMargin:'180px 0px'});
      perfObserver.observe(root);
    }
    document.addEventListener('visibilitychange',function(){
      pageVisible=!document.hidden;
      root.classList.toggle('h4-perf-paused',!pageVisible||!sceneVisible);
      if(pageVisible){last=performance.now();lastFrame=0}
    },{passive:true});

    requestAnimationFrame(tick);

    /* H4MAGNET93 — intent-aware magnetic full-screen settle.
       It only engages after real user scroll intent, snaps once, then deliberately
       releases on the next wheel/touch/key gesture so the section never traps scrolling. */
    var magnetEnabled=!reduce;
    var magnetBusy=false,magnetLocked=false,magnetIntent=false;
    var magnetBypassUntil=0,magnetLastY=window.scrollY,magnetRaf=0;
    if(magnetEnabled)document.documentElement.classList.add('h4-magnet-js');

    /* H4MAGNETSAFE94 */
    function magnetTopInset(){
      var maxBottom=0,ww=window.innerWidth||document.documentElement.clientWidth;
      var all=document.querySelectorAll('body *');
      for(var i=0;i<all.length;i++){
        var el=all[i];
        if(el===root||root.contains(el))continue;
        var cs=getComputedStyle(el);
        if(cs.position!=='fixed'&&cs.position!=='sticky')continue;
        var rr=el.getBoundingClientRect();
        if(rr.width<ww*.55||rr.height<36||rr.height>220)continue;
        if(rr.top>6||rr.bottom<=0||rr.bottom>220)continue;
        maxBottom=Math.max(maxBottom,rr.bottom);
      }
      return Math.max(0,Math.round(maxBottom));
    }
    function applyMagnetInset(){
      var inset=document.documentElement.classList.contains('h4-universe-immersive')?0:magnetTopInset();
      root.style.setProperty('--h4-magnet-inset',inset+'px');
      root.classList.toggle('is-magnet-locked',magnetLocked);
    }
    function magnetRelease(ms){
      magnetLocked=false;
      magnetBypassUntil=Date.now()+(ms||900);
      root.classList.remove('is-magnetizing','is-magnet-locked');
      document.documentElement.classList.remove('h4-universe-immersive');
      root.style.setProperty('--h4-magnet-inset','0px');
    }
    function magnetSnap(){
      if(!magnetEnabled||magnetBusy||Date.now()<magnetBypassUntil)return;
      magnetBusy=true;magnetLocked=true;magnetIntent=false;
      document.documentElement.classList.add('h4-universe-immersive');
      root.classList.add('is-magnetizing');
      try{root.scrollIntoView({behavior:'smooth',block:'start',inline:'nearest'})}
      catch(_){root.scrollIntoView(true)}
      setTimeout(function(){if(magnetLocked)applyMagnetInset()},180);
      setTimeout(function(){
        if(magnetLocked)applyMagnetInset();
        magnetBusy=false;
        root.classList.remove('is-magnetizing');
      },620);
    }
    function magnetCheck(){
      magnetRaf=0;
      if(!magnetEnabled||magnetBusy||Date.now()<magnetBypassUntil)return;
      var y=window.scrollY,dir=y-magnetLastY;magnetLastY=y;
      if(!magnetIntent||Math.abs(dir)<1)return;
      var r=root.getBoundingClientRect(),vh=window.innerHeight||document.documentElement.clientHeight;
      if(!vh||r.bottom<=0||r.top>=vh)return;
      var visible=Math.max(0,Math.min(r.bottom,vh)-Math.max(r.top,0));
      var ratio=visible/Math.min(vh,Math.max(1,r.height));
      if(magnetLocked){
        if(Math.abs(r.top)>vh*.18)magnetLocked=false;
        return;
      }
      var down=dir>0&&r.top<vh*.58&&r.bottom>vh*.16&&r.top>-vh*.82;
      var up=dir<0&&r.bottom>vh*.42&&r.top<vh*.84&&r.bottom<vh*1.82;
      if(ratio>.15&&(down||up))magnetSnap();
    }
    function scheduleMagnet(){
      if(magnetRaf)return;
      magnetRaf=requestAnimationFrame(magnetCheck);
    }
    if(magnetEnabled){
      window.addEventListener('wheel',function(e){
        magnetIntent=true;
        var r=root.getBoundingClientRect();
        if(Math.abs(r.top)<12&&Math.abs(e.deltaY)>2)magnetRelease(1050);
      },{passive:true});
      window.addEventListener('touchstart',function(){
        magnetIntent=true;
        var r=root.getBoundingClientRect();
        if(Math.abs(r.top)<12)magnetRelease(1200);
      },{passive:true});
      document.addEventListener('keydown',function(e){
        if(['PageDown','PageUp','ArrowDown','ArrowUp',' ','Home','End'].indexOf(e.key)===-1)return;
        magnetIntent=true;
        var r=root.getBoundingClientRect();
        if(Math.abs(r.top)<12)magnetRelease(1100);
      });
      window.addEventListener('scroll',scheduleMagnet,{passive:true});
    }

    if('ResizeObserver'in window){
      if(stage)new ResizeObserver(function(){starCache.delete(stars);starsDirtyDesktop=true}).observe(stage);
      if(mScene)new ResizeObserver(function(entries){var e=entries&&entries[0];refreshMobileMetrics(e&&e.contentRect);starCache.delete(mobileStars);starsDirtyMobile=true}).observe(mScene);
    }
  }

  function initAll(scope){qsa(scope||document,'[data-h4-root]').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});else initAll(document);
  document.addEventListener('shopify:section:load',function(e){initAll(e.target)});
})();